import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { motion } from "framer-motion";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    try {
      if (!localStorage.getItem("parth_cookie_consent")) {
        const t = setTimeout(() => setShow(true), 2000);
        return () => clearTimeout(t);
      }
    } catch {}
  }, []);
  const choose = (v) => {
    try { localStorage.setItem("parth_cookie_consent", v); } catch {}
    setShow(false);
    window.dispatchEvent(new Event("parth-consent"));
  };
  if (!show) return null;
  return (
    <motion.div className="cookie-banner" data-testid="cookie-banner" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}>
      <div className="cookie-head"><Cookie size={17}/><b>A quick word on cookies</b></div>
      <p>We use cookies only to keep the site secure and remember your preferences — no advertising or tracking cookies.</p>
      <div className="cookie-actions">
        <button data-testid="cookie-accept-button" className="cookie-accept" onClick={() => choose("accepted")}>Accept</button>
        <button data-testid="cookie-decline-button" className="cookie-decline" onClick={() => choose("declined")}>Decline</button>
        <Link data-testid="cookie-privacy-link" to="/privacy-policy" onClick={() => setShow(false)}>Privacy Policy</Link>
      </div>
    </motion.div>
  );
}
